"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadPayloadFactoryFromJS = exports.LoadPayloadFactory = void 0;
const immutable_1 = require("immutable");
const ITransaction_1 = require("../ITransaction");
exports.LoadPayloadFactory = (0, immutable_1.Record)({
    transactions: null,
    sourceWindowId: null,
    sourcePluginId: null,
    activeItemKey: null
});
const LoadPayloadFactoryFromJS = function (data) {
    const transactions = data.transactions
        ? data.transactions.map(item => (0, ITransaction_1.TransactionFactoryFromJS)(item))
        : null;
    return (0, exports.LoadPayloadFactory)({
        transactions: (0, immutable_1.List)(transactions),
        sourcePluginId: data.sourcePluginId,
        sourceWindowId: data.sourceWindowId,
        activeItemKey: data.activeItemKey
    });
};
exports.LoadPayloadFactoryFromJS = LoadPayloadFactoryFromJS;
//# sourceMappingURL=ILoadPayload.js.map